import {
    typography
} from "@hardware/Utilities/styleguide";
import {globalStyle} from "@hardware/Utilities/styleguide/GlobalStyle";
import { colorPalette as colors } from "@hardware/Utilities/variables";
import { setPreStyleGuideTheme } from "@insite/client-framework/ThemeConfiguration";

const setPreStyles = () => {
    // Add some pre styleguide customizations. These can be overridden by the styleguide.
    setPreStyleGuideTheme({
        colors,
        typography,
        globalStyle,
    });
};

export default setPreStyles;
